// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import loppEntity from './entities/lopp.json';
import loppMenu from '../pages/lopp/menu.json';
import loppFullForm from '../pages/lopp/forms/full.json';
import loppContextForm from '../pages/lopp/forms/context.json';
import loppMiniForm from '../pages/lopp/forms/mini.json';
import loppLookupForm from '../pages/lopp/forms/lookup.json';
import loppTableView from '../pages/lopp/views/table.json';
import loppStagesView from '../pages/lopp/views/stages.json';
import loppCardsView from '../pages/lopp/views/cards.json';
import loppInlineView from '../pages/lopp/views/inline.json';
import loppBacklogView from '../pages/lopp/views/backlog.json';
import loppSplitView from '../pages/lopp/views/split.json';
import loppCalendarView from '../pages/lopp/views/calendar.json';
import loppDashboardView from '../pages/lopp/views/dashboard.json';

/** Тип запису «Правова можливість» зі сторінками пакета: меню, форми та подання з pages/lopp/. */
export const loppDefinition: IRecordTypeDefinition = {
  ...loppEntity,
  views: assembleViewSet({
      table: loppTableView,
      stages: loppStagesView,
      cards: loppCardsView,
      inline: loppInlineView,
      backlog: loppBacklogView,
      split: loppSplitView,
      calendar: loppCalendarView,
      dashboard: loppDashboardView,
  }),
  form: loppFullForm,
  forms: { full: loppFullForm, context: loppContextForm, mini: loppMiniForm, lookup: loppLookupForm },
  menu: loppMenu,
} as IRecordTypeDefinition;
